export default "__VITE_ASSET__DHDrFV2j__"